import React from 'react';
import { exploreModules } from '../../constants/exploreModules';

const Usp = () => {
  return (
    <section className="row_am usp_section">
      <div className="inner_sec">
        <div className="container">
          <div className="row justify-content-center usp_module_row">
            {exploreModules.map((module) => (
              <div
                className="col-4 col-md-4 col-lg-3 col-xl-2 usp_module_col"
                key={module.id}
              >
                <div className="usp_box">
                  <div className="usp_icon">
                    <img src={module.icon} alt="" aria-hidden="true" />
                  </div>
                  <div className="usp_text">{module.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Usp;
